export default __webpack_public_path__ + "static/media/dinner3.487f6b77.jpg";